import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from '@craft/shared'
import { onAuthChange, getUserData } from './lib/firebase'
import LandingPage from './pages/LandingPage'
import DashboardPage from './pages/DashboardPage'
import LegalPage from './pages/LegalPage'

export default function App() {
  return (
    <AuthProvider onAuthChange={onAuthChange} getUserData={getUserData}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/terms" element={<LegalPage type="terms" />} />
          <Route path="/privacy" element={<LegalPage type="privacy" />} />
          <Route path="/tokushoho" element={<LegalPage type="tokushoho" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
